<template>
  <div class="mb-2">
    <div class="mb-1"><strong>{{ $t("Mẫu đơn thuốc") }}</strong></div>
    <el-input
      v-model="searchValue"
      class="mb-2"
      suffix-icon="el-icon-search"
      clearable
      :placeholder="$t('Tìm mẫu đơn thuốc')"
      @input="handleSearchPrescriptionForm"
    ></el-input>
    <div class="prescription-form-list" :class="{ 'prescription-form-list-empty': !prescriptionForms.length }">
      <div
        v-for="item in prescriptionForms"
        :key="item.id"
        class="prescription-form-item"
        :class="{ 'prescription-form-item-active': isSelectedPrescriptionForm(item) }"
        role="button"
        @click="togglePrescriptionForm(item)"
      >
        <div class="flex-1 min-w-0">
          <div class="fw-500 max-line-1">{{ item.name }}</div>
          <div class="fs-12 txt-grey-600">
            {{ getPrescriptionFormMedicineCount(item) }} thuốc
          </div>
        </div>
        <el-button
          @click.prevent.stop="deletePrescriptionForm(item)"
          type="text"
          size="small"
          icon="el-icon-delete"
          :loading="deletingPrescriptionFormId === item.id"
        ></el-button>
        <i
          class="fs-18"
          :class="isSelectedPrescriptionForm(item) ? 'el-icon-check txt-pri' : 'el-icon-plus txt-grey-600'"
        ></i>
      </div>
      <div v-if="!prescriptionForms.length" class="txt-grey-600 fs-14 p-2 text-center">
        {{ $t("Không có mẫu đơn thuốc") }}
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'SelectPrescriptionForm',
  props: {
    clearSelected: Number,
    refreshPrescriptionForm: Number,
    currentInventory: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      prescriptionForms: [],
      selectedPrescriptionForm: null,
      searchValue: '',
      deletingPrescriptionFormId: null
    }
  },
  watch: {
    $globalClinic () {
      this.getPrescriptionForm()
    },
    clearSelected () {
      this.selectedPrescriptionForm = null
    },
    refreshPrescriptionForm () {
      this.getPrescriptionForm()
    },
    currentInventory () {
      this.selectedPrescriptionForm = null
      this.getPrescriptionForm(this.searchValue)
    }
  },
  created () {
    this.getPrescriptionForm()
  },
  methods: {
    async getPrescriptionForm (searchValue) {
      if (!this.$globalClinic?.id) return

      try {
        const params = {
          page_num: 1,
          page_size: 10000,
          sort_by: 'created_at',
          order: 'desc',
          ws_id: this.$globalClinic?.id,
          keyword: searchValue
        }
        const response = await this.$rf
          .getRequest('DoctorRequest')
          .getPrescriptionForms(params)

        let forms = response.data?.data || []
        try {
          if (this.currentInventory) {
            forms = forms.filter((f) => {
              const inv = f?.pharma_inventory_id || f?.pharma_inventory || f?.inventory_id
              return String(inv) === String(this.currentInventory)
            })
          }
        } catch (e) {
          forms = response.data?.data || []
        }
        this.prescriptionForms = forms
      } catch (error) {
        console.log(error)
      }
    },
    handleDebounce: debounce(function (value) {
      this.getPrescriptionForm(value)
    }, 500),
    handleSearchPrescriptionForm (value) {
      this.handleDebounce(value)
    },
    handleSelectPrescriptionForm (data) {
      this.$emit('onSelect', data)
    },
    togglePrescriptionForm (item) {
      if (this.isSelectedPrescriptionForm(item)) {
        this.selectedPrescriptionForm = null
        this.handleSelectPrescriptionForm(null)
        return
      }

      this.selectedPrescriptionForm = item
      this.handleSelectPrescriptionForm(item)
    },
    isSelectedPrescriptionForm (item) {
      return this.selectedPrescriptionForm?.id === item?.id
    },
    getPrescriptionFormMedicineCount (item) {
      return item?.prescription_form_medicines?.length || item?.person_medicines?.length || 0
    },
    async deletePrescriptionForm (item) {
      try {
        await this.$confirm(
          `Bạn chắc chắn muốn xoá mẫu đơn thuốc <strong>${item.name}</strong> không?`,
          'Xác nhận xoá mẫu đơn thuốc',
          {
            confirmButtonText: 'Xác nhận',
            cancelButtonText: 'Huỷ',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }
        )

        this.deletingPrescriptionFormId = item.id
        const response = await this.$rf
          .getRequest('DoctorRequest')
          .deletePrescriptionForm(item.id)

        if (response?.status === 200 || response?.code === 200) {
          if (this.isSelectedPrescriptionForm(item)) {
            this.selectedPrescriptionForm = null
            this.handleSelectPrescriptionForm(null)
          }
          await this.getPrescriptionForm(this.searchValue)
          this.$message({
            message: 'Xoá mẫu đơn thuốc thành công',
            type: 'success'
          })
        }
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          console.log(error)
          this.$message({
            message: 'Xoá mẫu đơn thuốc thất bại',
            type: 'error'
          })
        }
      } finally {
        this.deletingPrescriptionFormId = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.prescription-form-list {
  max-height: 174px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.prescription-form-list-empty {
  min-height: 42px;
}

.prescription-form-item {
  min-height: 58px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}

.prescription-form-item:last-child {
  border-bottom: 0;
}

.prescription-form-item:hover,
.prescription-form-item-active {
  background: #dbeafe;
}

.prescription-form-item-active {
  border-left: 5px solid #20409b;
  background: #c7d2fe;
  color: #111827;
  box-shadow: inset 0 0 0 1px #20409b;
}
</style>
